import { ReactNode } from 'react';

interface PageContainerProps {
  isLoading?: boolean;
  children: ReactNode;
  className?: string;
  'data-testid'?: string;
}

export const PageContainer = ({
  isLoading, children, className = '', 'data-testid': testId,
}: PageContainerProps): JSX.Element => (
  <div
    data-testid={testId}
    className={`mx-auto w-full flex justify-center items-center bg-white ${
      // Fill the viewport while loading so the spinner centres; loaded content is
      // its own height and flows from the top.
      isLoading ? 'min-h-screen' : 'h-auto'
    } ${className}`}
  >
    {children}
  </div>
);
